import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AiSummary } from '../../types/inspection';

export interface AiSummaryState {
    aiSummaries: AiSummary[];
    loading: boolean;
    error: boolean;
    updateLoading: Record<string, boolean>; // Track loading per section
    updateError: boolean;
    updateSuccess: number; // Use a counter instead of boolean to trigger toasts every time
}

export const initialState: AiSummaryState = {
    aiSummaries: [],
    loading: true,
    error: false,
    updateLoading: {},
    updateError: false,
    updateSuccess: 0
};

export const aiSummarySlice = createSlice({
    name: 'aiSummary',
    initialState,
    reducers: {
        setAiSummaries: (state, action: PayloadAction<AiSummary[]>) => {
            state.aiSummaries = action.payload;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setError: (state, action: PayloadAction<boolean>) => {
            state.error = action.payload;
        },
        setUpdateLoading: (state, action: PayloadAction<{ sectionKey: string; loading: boolean }>) => {
            // Set loading for specific section only
            if (action.payload.loading) {
                state.updateLoading[action.payload.sectionKey] = true;
            } else {
                delete state.updateLoading[action.payload.sectionKey];
            }
        },
        setUpdateError: (state, action: PayloadAction<boolean>) => {
            state.updateError = action.payload;
        },
        setUpdateSuccess: (state) => {
            // Increment counter to trigger toast every time
            state.updateSuccess = state.updateSuccess + 1;
        }
    },
});

export const { 
    setAiSummaries,
    setLoading,
    setError,
    setUpdateLoading,
    setUpdateError,
    setUpdateSuccess
} = aiSummarySlice.actions;

export default aiSummarySlice.reducer;